import { render, staticRenderFns } from "./ItsContractRentCold.vue?vue&type=template&id=2badc13a&scoped=true&"
import script from "./ItsContractRentCold.vue?vue&type=script&lang=js&"
export * from "./ItsContractRentCold.vue?vue&type=script&lang=js&"
import style0 from "./ItsContractRentCold.vue?vue&type=style&index=0&id=2badc13a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2badc13a",
  null
  
)

export default component.exports